import React from 'react';
import '../styles/searchResultsSkeleton.css';

const SearchResultsSkeleton = () => {
  return (
    <div className="search-skeleton">
      <div className="search-header-skeleton">
        <div className="search-title-skeleton"></div>
        <div className="categories-skeleton">
          {Array.from({ length: 6 }).map((_, index) => (
            <div key={index} className="category-pill-skeleton"></div>
          ))}
        </div>
      </div>
      
      <div className="products-grid-skeleton">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="product-card-skeleton">
            <div className="product-image-skeleton"></div>
            <div className="product-content-skeleton">
              <div className="product-title-skeleton"></div>
              <div className="product-price-skeleton"></div>
              <div className="product-meta-skeleton">
                <div className="product-location-skeleton"></div>
                <div className="product-date-skeleton"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SearchResultsSkeleton;
